import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { EntityRef } from './EntityRef'
import { ProductAttributesGroupDto } from './ProductAttributesGroupDto'
import { ProductVariantsDto } from './ProductVariantsDto'
import { EntityRefOfString } from './EntityRefOfString'
import { ProductVideoDto } from './ProductVideoDto'
import { WellKnownProductAttributesDict } from './WellKnownProductAttributesDict'
/**
* Class ProductDto
*  Информация о продукте
*/
export class ProductDto extends ActiveModel {

  /**
  * id
  * ИД продукта<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * slug
  * <inheritdoc cref="P:Domain.Entities.Products.ProductChannel.Slug" />
  */
  @ActiveField('')
  slug: string = ''


/**
  * metaTitle
  * SEO: заголовок страницы товара в канале (meta title). <br><br>Если не задан — витрина генерирует его из данных товара<br>
  */
  @ActiveField(null)
  metaTitle: null | string = null


/**
  * metaDescription
  * SEO: описание страницы товара в канале (meta description). <br><br>Если не задано — витрина генерирует его из данных товара<br>
  */
  @ActiveField(null)
  metaDescription: null | string = null


/**
  * ogImageId
  * SEO: og-картинка страницы товара в канале (Domain.Entities.Resources.Resource.Id). <br><br>Если не задана — витрина берёт первое изображение товара<br>
  */
  @ActiveField(null)
  ogImageId: null | string = null


/**
  * @property categories
  * Категории продукта<br>  */
  @ActiveField({
    factory: [EntityRef, () => []]
  })
  categories: Array<EntityRef> = []


/**
  * @property groups
  * Информация о группах атрибутов в рамках канала<br>  */
  @ActiveField({
    factory: [ProductAttributesGroupDto, () => []]
  })
  groups: Array<ProductAttributesGroupDto> = []


  /**
  * variants
  * Информация о вариантах продукта, если они есть<br>  */
  @ActiveField({
    factory: [ProductVariantsDto, () => null]
  })
  variants: null | ProductVariantsDto = null


/**
  * @property images
  * Изображения продукта (упорядоченные)<br>  */
  @ActiveField({
    factory: [EntityRefOfString, () => []]
  })
  images: Array<EntityRefOfString> = []


/**
  * @property documents
  * Документы продукта (упорядоченные)<br>  */
  @ActiveField({
    factory: [EntityRefOfString, () => []]
  })
  documents: Array<EntityRefOfString> = []


/**
  * @property videos
  * Видео продукта (упорядоченные, после изображений в галерее)<br>  */
  @ActiveField({
    factory: [ProductVideoDto, () => []]
  })
  videos: Array<ProductVideoDto> = []


  /**
  * wellKnownAttributes
  * Значения известных атрибутов, где: <br><br>ключ: системный идентификатор Web.Api.Showcases.Controllers.Attributes.Models.AttributeDto.SystemName; <br><br>значение: типизированное представление значений атрибута<br>  */
  @ActiveField({
    factory: [WellKnownProductAttributesDict, () => undefined]
  })
  wellKnownAttributes?: WellKnownProductAttributesDict


  /**
  * inStock
  * Кол-во товара на складе<br>  */
  @ActiveField(0)
  inStock: number = 0


  /**
  * isFavorite
  * Добавлен ли товар в избранное<br>  */
  @ActiveField(false)
  isFavorite: boolean = false


/**
  * promoBadge
  * 
  */
  @ActiveField()
  promoBadge?: null | string


  /**
  * promoPrice
  *   */
  @ActiveField()
  promoPrice?: null | number


/**
  * promoTerms
  * 
  */
  @ActiveField()
  promoTerms?: null | string


  /**
  * hasCartPromo
  *   */
  @ActiveField()
  hasCartPromo?: boolean


  /**
  * hasCashbackPromo
  *   */
  @ActiveField()
  hasCashbackPromo?: boolean


  /**
  * promoDiscountPercent
  *   */
  @ActiveField()
  promoDiscountPercent?: null | number


  /**
  * promoCashbackAmount
  *   */
  @ActiveField()
  promoCashbackAmount?: null | number


  /**
  * promoCashbackPercent
  *   */
  @ActiveField()
  promoCashbackPercent?: null | number
}
